import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Login from "./login/login";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LocalResults from "./api/local_results";
import MainPage from "./main_page/main_page";
import MapResults from "./api/map_results";
import CsvCombiner from "./api/csv_combiner";
import Pipl from "./api/pipl";
import Gst from "./api/gst";
import Startupindia from "./api/startupindia";
import Mca from "./api/mca";
import Elasticsearch from "./api/elasticsearch";
import Email from "./api/email";
import Gst_scrapper_fast from "./api/gst_scrapper_fast";
import Linkedin_url_fast from "./api/linkedin_url_fast";
import JobsScraper from "./api/jobs_scraper";
import LinkedinEmail from "./api/linkedin_to_email";
import QCAutomation from "./api/qc_automation";
import SellersScraper from "./api/sellers_scraper";
import CompanyWebsite from "./api/company_website";
import SheetsCombiner from "./api/sheets_combiner"
import JobScraperBulk from "./api/job_scraper_bulk";
import YTScraper from "./api/yt_scraper";
import InstaScraper from "./api/insta_scraper"
import DnbScraper from "./api/dnb_scraper";
import PhoneNumberVerification from "./api/callerapi";
import ApolloEmail from "./api/apollo_email";
import CinPlcChecker from "./api/cin_plc_checker";

function LandingPage() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<App />} />
        <Route
          path="/api/local_result"
          element={
            <MainPage
              name={"Local Result"}
              desc={"Enter location and query for google search"}
              path={<LocalResults main_page={true} />}
            />
          }
        />
        <Route
          path="/api/map_result"
          element={
            <MainPage
              name={"Map result"}
              desc={"Enter location and query for google search"}
              path={<MapResults main_page={true} />}
            />
          }
        />

        <Route
          path="/api/company_website"
          element={
            <MainPage
              name={"Company Website"}
              desc={"Upload file and get website of company"}
              path={<CompanyWebsite main_page={true} />}
            />
          }
        />

        <Route
          path="/api/csv_combiner"
          element={
            <MainPage
              name={"CSV combiner"}
              desc={"Upload files to combine and remove duplicates"}
              path={<CsvCombiner main_page={true} />}
            />
          }
        />

        <Route
          path="/api/pipl"
          element={
            <MainPage
              name={"PIPL"}
              desc={
                "Upload file, choose email ID and column name and get results from PIPL"
              }
              path={<Pipl main_page={true} />}
            />
          }
        />
        <Route
          path="/api/gst"
          element={
            <MainPage
              name={"GST"}
              desc={
                "Upload file, choose column name and get gst, cin and company website"
              }
              path={<Gst main_page={true} />}
            />
          }
        />
        <Route
          path="/api/startupindia"
          element={
            <MainPage
              name={"Startupindia"}
              desc={
                "Get data from www.startupindia.gov.in, select filters and click on submit"
              }
              path={<Startupindia main_page={true} />}
            />
          }
        />
        <Route
          path="/api/mca"
          element={
            <MainPage
              name={"MCA"}
              desc={
                "Get data from https://www.mca.gov.in, upload CINs and click on submit"
              }
              path={<Mca main_page={true} />}
            />
          }
        />
        <Route
          path="/api/linkedin_url_fast"
          element={
            <MainPage
              name={"Linkedin url Fast"}
              desc={"Upload file, choose column name and get linkedin urls"}
              path={<Linkedin_url_fast main_page={true} />}
            />
          }
        />
        <Route
          path="/api/elasticsearch"
          element={
            <MainPage
              name={"Elasticsearch"}
              desc={"Upload file and get data from Elasticsearch"}
              path={<Elasticsearch main_page={true} />}
            />
          }
        />
        <Route
          path="/api/email"
          element={
            <MainPage
              name={"EMAIL"}
              desc={
                "Upload file, choose column name and get emails of the hotels"
              }
              path={<Email main_page={true} />}
            />
          }
        />

        <Route
          path="/api/gst_scrapper_fast"
          element={
            <MainPage
              name={"GSt Scrapper Fast"}
              desc={
                "Upload file, choose column name and get GST numbers of company name"
              }
              path={<Gst_scrapper_fast main_page={true} />}
            />
          }
        />

        <Route
          path="/api/linkedin_to_email"
          element={
            <MainPage
              name={"Linkedin URLs to Email"}
              desc={
                "Upload file with linkedin URLs and value proposition, and get intro mail"
              }
              path={<LinkedinEmail main_page={true} />}
            />
          }
        />

        <Route
          path="/api/gst"
          element={
            <MainPage
              name={"EMAIL"}
              desc={
                "Upload file, choose column name and get emails of the hotels"
              }
              path={<Email main_page={true} />}
            />
          }
        />

        <Route
          path="/api/jobs_scraper"
          element={
            <MainPage
              name={"JOBS SCRAPER"}
              desc={"scrapes data from naukri , simplyhired and indeed"}
              path={<JobsScraper main_page={true} />}
            />
          }
        />

        <Route
          path="/api/qc_automation"
          element={
            <MainPage
              name={"QC Automation"}
              desc={"Tests a Excel File as per QC standards"}
              path={<QCAutomation main_page={true} />}
            />
          }
        />

        <Route
          path="/api/scrape_sellers"
          element={
            <MainPage
              name={"Scrape Sellers"}
              desc={"scrape sellers info from amazon, flipkart, myntra"}
              path={<SellersScraper main_page={true} />}
            />
          }
        />

        <Route
          path="/api/sheets_combiner"
          element={
            <MainPage
              name={"Excel Sheet Combiner"}
              desc={"Combines rocketreach, sn and apollo data into single sheet"}
              path={<SheetsCombiner main_page={true} />}
            />
          }
        />

        <Route
          path="/api/sheets_combiner"
          element={
            <MainPage
              name={"Excel Sheet Combiner"}
              desc={"Combines rocketreach, sn and apollo data into single sheet"}
              path={<SheetsCombiner main_page={true} />}
            />
          }
        />
        
        <Route
        path="/api/jobs_scraper"
        element={
          <MainPage
            name={"Job Scraper"}
            desc={"Scrapes Job listings from Naukari, Simplyhired, Indeed"}
            path={<JobScraperBulk main_page={true} />}
          />
        }
        />

      <Route
        path="/api/insta_scraper"
        element={
          <MainPage
            name={"Instagram Scraper"}
            desc={"Scrapes Instagram user profiles, hashtags & posts"}
            path={<InstaScraper main_page={true} />}
          />
        }
      />

      <Route
        path="/api/yt_scraper"
        element={
          <MainPage
            name={"Youtube Scraper"}
            desc={"Scrapes Youtube based on the search terms"}
            path={<YTScraper main_page={true} />}
          />
        }
      />

      <Route
        path="/api/dnb_scraper"
        element={
          <MainPage
            name={"Dub & Bradsheet Directory Scraper"}
            desc={"Scrapes Dub & Bradsheet Directory based on the company names"}
            path={<DnbScraper main_page={true} />}
          />
        }
      />

      <Route
        path="/api/callerapi"
        element={
          <MainPage
            name={"Phone Number Verification API"}
            desc={"Scrapes & stores phone numbers verification results from the given excel file"}
            path={<PhoneNumberVerification main_page={true} />}
          />
        }
      />

      <Route
        path="/api/apollo_email"
        element={
          <MainPage
            name={"Apollo Email Finder"}
            desc={"Get email addresses from LinkedIn URLs using Apollo API"}
            path={<ApolloEmail main_page={true} />}
          />
        }
      />
      <Route
        path="/api/cin_plc_checker"
        element={
          <MainPage
            name={"CIN PLC Checker"}
            desc={"Upload Excel with CINs to identify companies converted from Private to Public"}
            path={<CinPlcChecker main_page={true} />}
          />
        }
      />

      </Routes>
      
    </div>
  );
}

const rootElement = document.getElementById("root");
ReactDOM.render(
  <BrowserRouter>
    <LandingPage />
  </BrowserRouter>,
  rootElement
);
